export type Deferred<T> = {
	promise: Promise<T>;
	resolve: (value: T | PromiseLike<T>) => void;
	reject: (reason?: any) => void;
};

export function createDeferred<T>(): Deferred<T> {
	const ret: any = {
		resolve: () => {},
		reject: () => {},
		promise: null,
	};
	ret.promise = new Promise<T>((res, rej) => {
		ret.resolve = res;
		ret.reject = rej;
	});
	return ret;
}

export function wait(ms: number, rej?: boolean) {
	return new Promise(function (resolve, reject) {
		setTimeout(rej ? reject : resolve, ms);
	});
}

export async function waitUntilTrue(fn: Function, retry?: number, max?: number) {
	if (!max) max = 2000;
	if (!retry) retry = 100;
	let start = Date.now();
	do {
		let res = await fn();
		if (res) return true;
		await wait(retry);
		// console.log(Date.now() - start);
	} while (Date.now() - start < max);
	return false;
}
